module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-api/project-detail-api.component.scss
// module id = ./src/app/projects/detail/project-detail-api/project-detail-api.component.scss
// module chunks = main